import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Paper,
  IconButton,
  CircularProgress,
  Button,
} from "@mui/material";
import Select from "react-select";
import Moment from "moment";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ReactSelect from "react-select";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Swal from "sweetalert2";
const MakePayment = (props) => {
  const [paymentDetails, setPaymentDetails] = useState([]);
  const claimId = props.claimId;
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };
  const paymentType = [
    { label: "Cash", value: "Cash" },
    { label: "Check", value: "Check" },
    { label: "Write off", value: "Write off" },
  ];

  const paymentSourseOption = [
    { label: "Patient", value: "Patient" },
    { label: "Carrier", value: "Carrier" },
    { label: "Provider", value: "Provider" },
  ];

  // ================= FETCH DATA =================
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (claimId > 0) {
      setLoading(true);
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/claims/PaymentById?claimId=${claimId}`,
          { headers },
        )
        .then((response) => {
          if (response) {
            setPaymentDetails(response);
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [claimId]);
  const [diagnosisList, setDiagnosisList] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/Diagnosis/Diagnosis`, {
        headers,
      })
      .then((response) => {
        var prac = [];
        response.forEach((field) => {
          prac.push({
            label: field.code,
            value: field.id,
          });
        });
        setDiagnosisList(prac);
      })
      .catch((error) => {});
  }, [claimId]);

  const [checkSearchResults, setcheckSearchResults] = React.useState(false);
  const [checkNoData, setCheckNoData] = React.useState([]);
  const [searchText, setSearchText] = useState("");
  const [checkSearchIndex, setcheckSearchIndex] = useState(null);
  const [loadingIndex, setLoadingIndex] = useState(null);
  const highlightMatch = (text, search) => {
    if (!search) return text;

    const regex = new RegExp(`(${search})`, "ig");
    const parts = text.split(regex);

    return parts.map((part, i) =>
      part.toLowerCase() === search.toLowerCase() ? (
        <span
          key={i}
          style={{
            color: "#1976d2",
            fontWeight: 700,
            backgroundColor: "#e3f2fd",
            padding: "2px 4px",
            borderRadius: 4,
          }}
        >
          {part}
        </span>
      ) : (
        part
      ),
    );
  };

  const searchTimeout = React.useRef(null);
  const onChangeHandle = async (value, index) => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    if (!value.trim()) {
      setCheckNoData([]);
      setLoadingIndex(null);
      return;
    }

    searchTimeout.current = setTimeout(async () => {
      try {
        setLoadingIndex(index);

        const sendData = {
          id: 0,
          checkno: value,
        };

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/claims/SearchERA`,
          sendData,
          { headers },
        );

        setCheckNoData(response || []);
      } catch (error) {
        console.error("There was an error!", error);
        setCheckNoData([]);
      } finally {
        setLoadingIndex(null);
      }
    }, 400); // debounce
  };
  const saveData = () => {
    const postData = paymentDetails;
    axios
      .post(`${process.env.REACT_APP_API_URL}/claims/addpayment`, postData, {
        headers,
      })
      .then((response) => {
        props.handleCloseMakePayment();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Payment saved successfully.",
          showConfirmButton: false,
          timer: 1500,
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) swalPopup.style.zIndex = 5000;
          },
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong while saving payment.",
          confirmButtonColor: "#1976d2",
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) swalPopup.style.zIndex = 5000;
          },
        });
      });
  };
  const addNewPaymentRow = (index) => {
  const base = paymentDetails[index];

  const newRow = {
    id: 0,
    claimId: claimId,
    code: base.code,
    dosTo: base.dosTo,
    dxPointer1: base.dxPointer1,
    patientId: base.patientId,
    charges:0,
    paymentType: "",
    paymentSourse: "",
    eRAId: 0,
    checkno: "",
    payer: "",
    checkdate: "",
    checkamount: 0,
    allowamount: 0,
    paidamount: 0,
    adjustmentamount: 0,
    writeoff: 0,
    writeOffReason: "",
    balance: 0,
  };

   const updated = [...paymentDetails];
  updated.splice(index + 1, 0, newRow);
  setPaymentDetails(updated);
};
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 16px",
          background: "linear-gradient(70deg, #4facfe, #00f2fe)",
          color: "#fff",
          borderTopLeftRadius: 6,
          borderTopRightRadius: 6,
          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        }}
      >
        {/* Left: Icon + Label */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <AccountBalanceIcon style={{ fontSize: 24 }} />
          <Typography
            variant="h6"
            component="span"
            style={{ fontWeight: "bold" }}
          >
            Make Payment
          </Typography>
        </div>

        <IconButton
          size="small"
          onClick={props.handleCloseMakePayment}
          sx={{
            color: "#fff",
            backgroundColor: "rgba(255,255,255,0.1)",
            "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
          }}
        >
          <CancelOutlinedIcon />
        </IconButton>
      </div>

      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
            width: "100%",
          }}
        >
          <CircularProgress size={40} />
        </div>
      ) : paymentDetails && paymentDetails.length > 0 ? (
        paymentDetails.map((row, index) => (
          <Paper
            key={index}
            variant="outlined"
            square
            sx={{
              p: 3,
              m: 2,
              borderRadius: "15px",
           background: row.id === 0 ? "#e8f5e9" : "#ffffff", 
    border: row.id === 0 ? "2px solid #4caf50" : "1px solid #e0e0e0",
    boxShadow: row.id === 0
      ? "0 8px 20px rgba(76,175,80,0.25)"
      : "0 8px 20px rgba(0,0,0,0.08)",
            }}
          >
            <Grid container spacing={2}>
              {/* Procedure */}
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography>Procedure code:</Typography>
                <TextField
                  size="small"
                  fullWidth
                  value={row.code}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              {/* Diagnosis */}
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography>Diagnosis code:</Typography>
                <ReactSelect
                  isMulti
                  value={
                    row.dxPointer1
                      ? row.dxPointer1.split(",").map((code) => {
                          const found = diagnosisList.find(
                            (opt) => String(opt.value) === code.trim(),
                          );
                          return found || { label: code, value: code };
                        })
                      : []
                  }
                  onChange={(selectedOptions) => {
                    const updated = [...paymentDetails];

                    const selectedValues = selectedOptions
                      ? selectedOptions.map((opt) => opt.value)
                      : [];

                    updated[index].dxPointer1 = selectedValues.join(", ");

                    setPaymentDetails(updated);
                  }}
                  options={diagnosisList}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      width: "99%",
                    }),
                  }}
                  isDisabled
                />
              </Grid>

              {/* DOS */}
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography>DOS</Typography>
                <TextField
                  size="small"
                  fullWidth
                  value={
                    row.dosTo ? Moment(row.dosTo).format("MM/DD/YYYY") : ""
                  }
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              {/* Charges */}
              {row.charges > 0 ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography>Charge $</Typography>
                <TextField
                  size="small"
                  fullWidth
                  value={row.charges}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              ): (
              <Grid item xs={12} sm={6} md={4} lg={3}></Grid>
              )}

              {/* Payment Type */}
              <Grid item xs={3}>
                <Typography>Payment Type:</Typography>

                <Select
                  options={paymentType}
                  placeholder="Payment Type"
                  value={
                    row.paymentType
                      ? paymentType.find(
                          (option) => option.value === row.paymentType,
                        )
                      : null
                  }
                  onChange={(selectedOption) => {
                    let updatedRows = [...paymentDetails];
                    updatedRows[index].paymentType = selectedOption.value;
                    setPaymentDetails(updatedRows);
                  }}
                />
              </Grid>

              {/* Payment Source */}
              <Grid item xs={3}>
                <Typography>Payment Source:</Typography>
                <Select
                  options={paymentSourseOption}
                  placeholder="Payment Sourse"
                  value={
                    row.paymentSourse
                      ? paymentSourseOption.find(
                          (option) => option.value === row.paymentSourse,
                        )
                      : null
                  }
                  onChange={(selectedOption) => {
                    let updatedRows = [...paymentDetails];
                    updatedRows[index].paymentSourse = selectedOption.value;
                    setPaymentDetails(updatedRows);
                  }}
                />
              </Grid>

              {row.paymentType == "Check" && (
                <>
                  <Grid item xs={3}>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        textDecoration: "underline",
                        mb: 0.5,
                      }}
                    >
                      Check Number:
                    </Typography>

                    <ClickAwayListener
                      onClickAway={() => {
                        setcheckSearchIndex(null);
                        setCheckNoData([]);
                      }}
                    >
                      <div style={{ position: "relative" }}>
                        <TextField
                          size="small"
                          autoComplete="off"
                          fullWidth
                          placeholder="Search Check Number"
                          value={
                            checkSearchIndex === index
                              ? searchText
                              : row.checkno || ""
                          }
                          onChange={(e) => {
                            const val = e.target.value;
                            setSearchText(val);
                            setcheckSearchIndex(index);
                            onChangeHandle(val, index);
                          }}
                          sx={{ backgroundColor: "#fff" }}
                          InputProps={{
                            endAdornment:
                              loadingIndex === index ? (
                                <CircularProgress size={18} />
                              ) : null,
                          }}
                        />

                        {checkSearchIndex === index && searchText && (
                          <div
                            style={{
                              position: "absolute",
                              top: "42px",
                              width: "100%",
                              maxHeight: 180,
                              overflowY: "auto",
                              background: "#fff",
                              border: "1px solid #c8e0ff",
                              borderRadius: 8,
                              boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
                              zIndex: 1000,
                            }}
                          >
                            {loadingIndex === index ? (
                              <div
                                style={{
                                  padding: "12px",
                                  textAlign: "center",
                                  color: "#67748e",
                                  fontSize: 14,
                                }}
                              >
                                Searching…
                              </div>
                            ) : checkNoData.length > 0 ? (
                              checkNoData.map((item) => (
                                <div
                                  key={item.id}
                                  style={{
                                    padding: "10px 14px",
                                    cursor: "pointer",
                                    borderBottom: "1px solid #eee",
                                    fontWeight: 500,
                                    color: "#344767",
                                  }}
                                  onClick={() => {
                                    const rows = [...paymentDetails];

                                    rows[index] = {
                                      ...rows[index],
                                      eRAId: item.id,
                                      checkno: item.checkno,
                                      payer: item.payer,
                                      checkdate: item.checkdate,
                                      checkamount: item.checkamount,
                                    };

                                    setPaymentDetails(rows);
                                    setSearchText(item.checkno);
                                    setcheckSearchIndex(null);
                                    setCheckNoData([]);
                                  }}
                                >
                                  {highlightMatch(item.checkno, searchText)}
                                </div>
                              ))
                            ) : (
                              /* ✅ NO MATCH MESSAGE */
                              <div
                                style={{
                                  padding: "14px",
                                  textAlign: "center",
                                  color: "#d32f2f",
                                  fontWeight: 600,
                                  fontSize: 14,
                                }}
                              >
                                No matching check found
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </ClickAwayListener>
                  </Grid>
                </>
              )}
              {row.paymentType == "Check" && (
                <Grid item xs={3}>
                  <Typography
                    style={{
                      fontSize: "16px",
                      textDecoration: "underline",
                    }}
                  >
                    Payer:
                  </Typography>
                  <TextField
                    size="small"
                    placeholder="Payer..."
                    fullWidth
                    value={row.payer}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
              )}
              {row.paymentType == "Check" ? (
                <>
                  <Grid item xs={3}>
                    <Typography
                      style={{
                        fontSize: "16px",
                        textDecoration: "underline",
                      }}
                    >
                      Check Date:
                    </Typography>
                    <TextField
                      size="small"
                      value={row.checkdate}
                      style={{ width: "99%" }}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <Typography
                      style={{
                        fontSize: "16px",
                        textDecoration: "underline",
                      }}
                    >
                      Check Amount:
                    </Typography>
                    <TextField
                      size="small"
                      placeholder="Check amount..."
                      fullWidth
                      value={row.checkamount}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                </>
              ) : (
                ""
              )}
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography>Allowed Amount</Typography>

                <TextField
                  size="small"
                  placeholder="Enter Allowed Amount"
                  fullWidth
                  value={row.allowamount}
                  sx={{
                    backgroundColor: "#fff",
                  }}
                  onChange={(ev) => {
                    console.log("ee:", ev.target.value);
                    var _row = paymentDetails;
                    _row[index].allowamount = ev.target.value;

                    setPaymentDetails([..._row]);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography>Paid Amount</Typography>

                <TextField
                  size="small"
                  placeholder="Enter Paid Amount"
                  fullWidth
                  sx={{
                    backgroundColor: "#fff",
                  }}
                  value={row.paidamount}
                  onChange={(ev) => {
                    const value = ev.target.value;
                    var _row = paymentDetails;
                    _row[index].paidamount = value;
                    _row[index].balance =
                      Number(_row[index].charges || 0) -
                      Number(_row[index].writeoff || 0) -
                      Number(_row[index].adjustmentamount || 0) -
                      Number(_row[index].paidamount || 0);

                    setPaymentDetails([..._row]);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography>Adjustment Amount</Typography>

                <TextField
                  size="small"
                  placeholder="Enter Adjustment Amount"
                  fullWidth
                  sx={{
                    backgroundColor: "#fff",
                  }}
                  value={row.adjustmentamount}
                  onChange={(ev) => {
                    var _row = paymentDetails;

                    _row[index].adjustmentamount = ev.target.value;
                    _row[index].balance =
                      Number(_row[index].charges || 0) -
                      Number(_row[index].writeoff || 0) -
                      Number(_row[index].adjustmentamount || 0) -
                      Number(_row[index].paidamount || 0);
                    setPaymentDetails([..._row]);
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography>Write Off</Typography>

                <TextField
                  size="small"
                  placeholder="Enter Write off Amount Here"
                  fullWidth
                  sx={{
                    backgroundColor: "#fff",
                  }}
                  value={row.writeoff}
                  onChange={(ev) => {
                    var _row = paymentDetails;
                    _row[index].writeoff = ev.target.value;
                    _row[index].balance =
                      Number(_row[index].charges || 0) -
                      Number(_row[index].writeoff || 0) -
                      Number(_row[index].adjustmentamount || 0) -
                      Number(_row[index].paidamount || 0);
                    setPaymentDetails([..._row]);
                  }}
                />
              </Grid>
              <Grid item xs={9}>
                <Typography>WriteOff Reason</Typography>

                <TextField
                  size="small"
                  fullWidth
                  value={row.writeOffReason}
                  sx={{
                    backgroundColor: "#fff",
                  }}
                  onChange={(ev) => {
                    const updatedDetails = [...paymentDetails];
                    updatedDetails[index].WriteOffReason = ev.target.value;
                    setPaymentDetails(updatedDetails);
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <Typography>Balance</Typography>
                <TextField
                  size="small"
                  fullWidth
                 value={Number(Number(row.balance || 0).toFixed(2))}
                  onChange={(ev) => {
                    console.log("ee:", ev.target.value);
                    var _row = paymentDetails;
                    setPaymentDetails([..._row]);
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
                    <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
        <Button
          variant="gradient"
          onClick={() => addNewPaymentRow(index)}
          disabled={row.id==0}
                        style={{
                        height: "40px",
                        color: "white",
                        marginRight:'3px',
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "right",
                        justifyContent: "right",
                        textTransform: "none",
                        gap: "8px",
                        background: "linear-gradient(135deg, #667eea, #764ba2)", // 💜 NEW (instead of green)
                        borderRadius: "10px",
                        boxShadow: "0 4px 12px rgba(102,126,234,0.4)",
                      }}
        >
          Add New Payment Row
        </Button>
         <Button
        variant="contained"
        sx={{
          background: "linear-gradient(70deg, #4facfe, #00f2fe)",
          padding: "10px 25px",
          borderRadius: "10px",
            height: "40px",
                        color: "white",
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "right",
                        justifyContent: "right",
                        textTransform: "none",
        }}
        onClick={saveData}
        disabled={paymentDetails.length < 0}
      >
        Save Payment
      </Button>
      </Grid>
            </Grid>
          </Paper>
        ))
      ) : (
        <Typography
          style={{
            textAlign: "center",
            padding: "20px",
            color: "#999",
          }}
        >
          No Record Found
        </Typography>
      )}

     
    </>
  );
};

export default MakePayment;
